import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { selectAnatomy as parts } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const baseStyle = definePartsStyle({
  defaultProps: {
    size: 'sm',
  },
  field: {
    borderRadius: 'var(--chakra-radii-base)',
  },
});

const variants = definePartsStyle({
  outline: {
    field: {
      color: 'gray.600',
    },
  },
});

const selectTheme = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    size: 'sm',
  },
  variants,
});

export default selectTheme;
